/*
    Limitations:
        - to don't lose related js there is the event "section:fetch". Move all of your js
        to e.g. main() function and use event listener for section's WRAPPER, here is the example:

        sectionWrapper.addEventListener('section:fetch', function (event) {
            main();
        });

        - First element of section file shold be a root html elemt, if you need to use some link or script elements,
        you can use it inside of this root element or after, but NOT before this element.

        - Root element inside of section file must have data-section-id="{{ section.id }}"
*/

function unwrap(wrapper) {
    // place childNodes in document fragment
    var docFrag = document.createDocumentFragment();
    while (wrapper.firstChild) {
        var child = wrapper.removeChild(wrapper.firstChild);
        docFrag.appendChild(child);
    }

    // replace wrapper with document fragment
    wrapper.parentNode.replaceChild(docFrag, wrapper);
}

function updateMockup(mockup, sectionElement) {
    var parent = sectionElement.parentNode;
    if (!!parent) {
        parent.innerHTML = mockup;
        unwrap(parent.children[0]);
        return parent.children[0];
    }
}

function fetchSection(sectionId, sectionElement) {
    if (!(sectionId) || !(sectionElement)) {
        console.error('fetchSection: !(sectionId) || !(sectionElement)')
        return;
    }

    var variantId = window.location.href.split('variant=').pop();
    var url = '?sections=' + sectionId + '&variant=' + variantId;
    fetch(url).then(res => res.json()).then(data => {
        var newSection = updateMockup(data[sectionId], sectionElement);
        var sectionFetchEvent = new Event("section:fetch", {bubbles: true});
        newSection.parentNode.dispatchEvent(sectionFetchEvent);
    });
}

function refreshSections(sectionsToRefresh) {
    sectionsToRefresh.forEach(function (s) {
        var section = document.querySelector(s);
        if (!!section) {
            fetchSection(section.dataset.sectionId, section);
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    var sectionsToRefreshSelectors = ['.taste-profile', '.tabs-section', '.ed-accordion-section-container'];
    var dataVariantInputs = document.querySelectorAll('[data-variant-input]');

    dataVariantInputs.forEach(function (input) {
        input.addEventListener('change', function () {
            refreshSections(sectionsToRefreshSelectors);
        });
    });
});